// src/components/CreateWebsiteModal.tsx

import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

interface CreateWebsiteModalProps {
  show: boolean;
  handleClose: () => void;
  handleSubmit: (e: React.FormEvent) => void;
  formData: {
    name: string;
    projectCode: string;
    [key: string]: any; // in case you add more fields
  };
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CreateWebsiteModal: React.FC<CreateWebsiteModalProps> = ({
  show,
  handleClose,
  handleSubmit,
  formData,
  handleFormChange
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create a New Website</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="websiteName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleFormChange}
            />
          </Form.Group>

          <Form.Group controlId="websiteProjectCode">
            <Form.Label>Project Code</Form.Label>
            <Form.Control
              type="text"
              name="projectCode"
              required
              value={formData.projectCode}
              onChange={handleFormChange}
            />
          </Form.Group>

          <Form.Check
            className="mt-3"
            id="websiteIsInternal"
            type="switch"
            name="isInternal"
            label="Internal Gemstone site (customer contract not required)"
            checked={Boolean(formData.isInternal)}
            onChange={handleFormChange}
          />

          {/* Additional fields can be added here in a similar manner */}

          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateWebsiteModal;
